var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOthersIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39.5,
    stroke: "#707070"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 41.7123C46.6195 41.7123 51.9857 36.3461 51.9857 29.7266C51.9857 23.107 46.6195 17.7408 40 17.7408C33.3805 17.7408 28.0143 23.107 28.0143 29.7266C28.0143 36.3461 33.3805 41.7123 40 41.7123Z",
    fill: "#FFCC80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5469 54.2459C59.604 50.9674 57.6237 48.0828 54.903 46.0248C52.1822 43.9668 48.8677 42.8461 45.4563 42.8309H34.5664C31.156 42.8498 27.8432 43.9719 25.1232 46.0293C22.4032 48.0868 20.4221 50.9693 19.4758 54.2459H19.453C19.1844 55.1801 19.1363 56.164 19.3127 57.12C19.489 58.0759 19.885 58.9779 20.4693 59.7548C21.0536 60.5317 21.8104 61.1622 22.6799 61.5968C23.5494 62.0314 24.508 62.2582 25.4801 62.2592H54.4741C55.4501 62.2653 56.414 62.0437 57.2894 61.6122C58.1647 61.1806 58.9274 60.5509 59.5169 59.7731C60.1064 58.9952 60.5064 58.0907 60.6852 57.1312C60.864 56.1718 60.8166 55.1838 60.5469 54.2459Z",
    fill: "#27A2DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOthersIcon);
export default __webpack_public_path__ + "static/media/others-icon.e49aeb7ffa4f608d7d1652c5e2ce6604.svg";
export { ForwardRef as ReactComponent };